module.exports = __webpack_public_path__ + "img/b130a20.svg";